import { ApiKeyFetch } from 'api/fetchers/apiKey';
import BreadCurmb from 'components/BreadCrumbMex/BreadCrumb';
import BreadCrumbPasosV2 from 'components/BreadCrumbMex/BreadCrumbPasosV2';
import { CheckCompuesto } from 'components/DynamicForm/components/CheckCompuesto';
import { SimpleCheckBox } from 'components/InputsMex/SimpleInputs';
import SimpleContainer from 'components/InputsMex/containers/SimpleContainer';
import { TextInputOnBlur } from 'components/InputsMex/inputs';
import { inputNumericoEnteros } from 'components/InputsMex/validaciones';
import Page from 'components/Page';
import useCustomToast from 'hooks/useCustomToasts';
import useQueryParams from 'hooks/useQueryParams';
import useUsuario from 'hooks/useUsuario';
import { chunk } from 'lodash';
import { Button as BtnInfo } from 'primereact/button';
import React, { useCallback, useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { FormProvider, useForm } from 'react-hook-form';
import { useHistory } from 'react-router';
import { PASOS_BREADCRUMBS } from 'utils/constants';
import PRODUCTOS from 'utils/constants/PRODUCTOS';
import { guardarTrackingV2 } from 'utils/tracking';
import { regex } from 'utils/validaciones';
import Loading from 'wrappers/Loading';
import useSuscriptorFunctions from '../components/useSusciptorFunctions';
import { CASUALITY_GENERAL } from '../constantes';
import { validarLimites } from '../constantes/funciones';
import './styles.scss';

const API = ApiKeyFetch.instance();

export const CoberturasCasualityGeneral = () => {
  const { addWarningToast } = useCustomToast();
  const methods = useForm({ mode: 'onChange' });
  const { reset, getValues } = methods;
  const history = useHistory();
  const params = useQueryParams();
  const { id = '' } = params;
  const { cliCodigoCore = '', ...dataUsuario } = useUsuario();
  const suscriptorFunctions = useSuscriptorFunctions();

  const [loading, setLoading] = useState(false);
  const [catalogo, setCatalogo] = useState({});
  const [infoFormAnterior, setInfoFormAnterior] = useState({});

  const onSubmit = async (values) => {
    const { coberturasAdicionales, coberturaBasica, ...rest } = values;

    const arrMapCoberturas = catalogo?.coberturas?.map((item) => {
      if (item.habilitaCampo) return values?.coberturasAdicionales?.[item?.value];
      return {
        ...item,
        seleccionado: values?.coberturasAdicionales?.[item?.value],
      };
    });

    rest.coberturasAdicionales = arrMapCoberturas;
    rest.coberturaBasica = catalogo?.mensajes?.coberturaBasica?.cobertura;

    guardarTrackingV2(
      params?.id || '',
      'Click Continuar pantalla 2',
      'Guardado pantalla 2',
      CASUALITY_GENERAL.endpoints.guardarTracking,
    );

    setLoading(true);
    try {
      const Body = {
        ...rest,
        idCotizacion: params?.id,
        usuCotiza: {
          idUsuario: cliCodigoCore,
        },
      };

      const response = await API.post(CASUALITY_GENERAL.endpointsV2.guardarLead2, Body);
      if (response?.transaccion === true) {
        const tarifacion = await API.post(CASUALITY_GENERAL.endpointsV2.tarifacion, {
          idCotizacion: id,
        });
        if (tarifacion?.transaccion && !tarifacion.errores) {
          return history.push(`${CASUALITY_GENERAL.urls.resumen}?id=${response?.id}`);
        }
        if (tarifacion?.tarifacion?.permitirEmitir === false) {
          addWarningToast(response?.tarifacion?.msgError, { autoDismiss: false });
        }
        if (tarifacion?.errores) {
          addWarningToast(tarifacion?.errores?.errorDescripcion, { autoDismiss: false });
        }
      }
    } catch (error) {}
    setLoading(false);
    methods.reset({ ...values });
  };

  const onBack = () => {
    guardarTrackingV2(
      params?.id || '',
      'Click atrás pantalla 2 Casuality',
      'Guardado pantalla 2',
      CASUALITY_GENERAL.endpoints.guardarTracking,
    );
    history.push(`${CASUALITY_GENERAL.urls.datosCliente}?id=${params?.id}`);
  };

  const init = useCallback(async () => {
    guardarTrackingV2(
      id || '',
      'Carga pantalla 2',
      'Consulta catalogo 2',
      CASUALITY_GENERAL.endpoints.guardarTracking,
    );

    setLoading(true);
    try {
      const Body = {
        idCotizacion: id,
        usuCotiza: {
          mongoUsuario: cliCodigoCore,
        },
      };
      const [response, responseResumen] = await Promise.all([
        API.post(CASUALITY_GENERAL.endpointsV2.catalogo2, Body),
        API.post(CASUALITY_GENERAL.endpointsV2.resumen, { idCotizacion: id }),
      ]);
      console.log(response);
      console.log(responseResumen);
      if (response?.transaccion === true && responseResumen?.transaccion) {
        const { redirect, link } = await suscriptorFunctions.validate(
          { ...responseResumen, pasoActual: 'seleccionPlanEquivalencia' },
          { cliCodigoCore, ...dataUsuario }
        );
        if (redirect) return history.push(link);
      }

      if (response?.transaccion === true) {
        const { transaccion, ...rest } = response;
        const coberturasCampo = rest.coberturas.filter((cob) => cob.habilitaCampo === true);
        const coberturasSinCampo = rest.coberturas.filter((cob) => cob.habilitaCampo === false);

        setCatalogo({
          ...rest,
          coberturasWCMapped: coberturasCampo,
          coberturasWOCMapped: chunk(coberturasSinCampo, 4),
        });

        if (responseResumen?.transaccion === true && responseResumen?.carrito?.carProductos?.[0]) {
          const { coberturaBasica, coberturasAdicionales, ...restResumen } =
            responseResumen?.carrito?.carProductos?.[0];
          const mappedCoberturas = {};
          if (coberturasAdicionales) {
            coberturasAdicionales.forEach((item) => {
              if (!item?.informacion) mappedCoberturas[item?.value] = item?.seleccionado;
              else mappedCoberturas[item?.value] = { ...item };
            });
          }
          reset({
            coberturasAdicionales: mappedCoberturas,
            ...restResumen,
          });
        }
        if (responseResumen?.transaccion === true && responseResumen?.carrito?.carContratante) {
          setInfoFormAnterior({
            monedaObj: responseResumen?.carrito?.carContratante?.monedaObj,
            tipoProducto: responseResumen?.carrito?.carContratante?.tipoProducto,
          });
          reset({
            estimadoAnualVentas: responseResumen?.carrito?.carContratante?.estimadoAnual,
            ...getValues()
          });
        }
      }
    } catch (error) {}
    setLoading(false);
  }, [cliCodigoCore, id, reset]);

  useEffect(() => {
    if (dataUsuario.isDTC) {
      addWarningToast('Por favor, inicie sesión para continuar con la cotización');
      return history.push('/');
    }
    init();
  }, [init]);

  return (
    <Loading loading={loading}>
      <div className="cr-content">
        <Page>
          <BreadCurmb {...PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY_GENERAL].breadCrumb} />

          <BreadCrumbPasosV2
            {...PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY_GENERAL].breadCrumbPasosCotizacion[2]}
            styleimg="height200px mr-3"
            pasos={PASOS_BREADCRUMBS[PRODUCTOS.CASUALITY_GENERAL]?.pasosCotizacion}
          />
          <FormProvider {...methods}>
            <form onSubmit={methods.handleSubmit(onSubmit)}>
              <div className="d-flex flex-wrap justify-content-center">

                <div className="col-12 col-lg-8 d-flex flex-wrap justify-content-center">
                  <div className="col-12 px-3 mx-3 py-4">
                    <h3 className="font-mex p-3" style={{ fontSize: '30px', background: '#f2f2f2' }}>
                      {catalogo?.productoSeleccionado && `Producto: ${catalogo?.productoSeleccionado}`}
                    </h3>
                  </div>

                  <div className="form-group col-12 px-3 mx-3 mt-3">
                    <div className="row">
                      <div className="form-group col-6 py-4">
                        <SimpleContainer label="Ubicación del cliente*" name="ubicacionCliente" showOk={false}>
                          <TextInputOnBlur
                            inputProps={{
                              name: 'ubicacionCliente',
                              type: 'string',
                            }}
                            rules={{
                              required: regex.requiredMessage,
                              pattern: {
                                value: regex.regexRazonSocial.value,
                                message: regex.regexRazonSocial.mensaje,
                              },
                              validate: {
                                longitud: (value) => {
                                  return validarLimites(
                                    value?.length,
                                    catalogo?.validaciones?.['ubicacionCliente']?.max,
                                    catalogo?.validaciones?.['ubicacionCliente']?.min,
                                    catalogo?.validaciones?.['ubicacionCliente']?.msgError
                                  );
                                },
                              },
                            }}
                          />
                        </SimpleContainer>
                      </div>

                      <div className="form-group col-6 py-4" style={{ opacity: '0.5' }}>
                        <SimpleContainer
                          label={`Estimado anual de ventas (${
                            infoFormAnterior?.monedaObj?.value === 1 ? 'USD' : 'MXN'
                          })* `}
                          name="estimadoAnualVentas"
                          showOk={false}
                        >
                          <TextInputOnBlur
                            inputProps={{
                              name: 'estimadoAnualVentas',
                              type: 'number',
                              onKeyDown: inputNumericoEnteros,
                            }}
                            prefijo="$ "
                            numerico={true}
                            disabled
                            rules={{
                              required: regex.requiredMessage,
                              pattern: {
                                value: regex.nombre.value,
                                message: regex.nombre.mensaje,
                              },
                            }}
                          />
                        </SimpleContainer>
                      </div>

                      {catalogo?.tipoProducto?.campoAdicional && catalogo?.tipoProducto?.campo?.type && (
                        <div className="form-group col-6 py-4">
                          <SimpleContainer
                            label={catalogo?.tipoProducto?.campo?.label}
                            name={catalogo?.tipoProducto?.campo?.name}
                            showOk={false}
                          >
                            <TextInputOnBlur
                              inputProps={{
                                name: catalogo?.tipoProducto?.campo?.name,
                                type: catalogo?.tipoProducto?.campo?.type,
                              }}
                              numerico={true}
                              rules={
                                catalogo?.tipoProducto?.campo?.requerido
                                  ? {
                                      required: regex.requiredMessage,
                                      validate: {
                                        limits: (value) => {
                                          if (catalogo?.tipoProducto?.campo) {
                                            return validarLimites(
                                              value,
                                              catalogo?.tipoProducto?.campo?.max,
                                              catalogo?.tipoProducto?.campo?.min,
                                              'El dato ingresado debe ser entre ' +
                                                catalogo?.tipoProducto?.campo?.min +
                                                ' y ' +
                                                catalogo?.tipoProducto?.campo?.max
                                            );
                                          }
                                        },
                                      },
                                    }
                                  : {}
                              }
                            />
                          </SimpleContainer>
                        </div>
                      )}

                      {catalogo?.tipoProducto?.campoAdicional && !catalogo?.tipoProducto?.campo?.type && (
                        <div className="form-group col-6 py-4">
                          <SimpleContainer
                            label={catalogo?.tipoProducto?.campo?.label}
                            name={catalogo?.tipoProducto?.campo?.name}
                            showOk={false}
                          >
                            <TextInputOnBlur
                              inputProps={{
                                name: catalogo?.tipoProducto?.campo?.name,
                                type: catalogo?.tipoProducto?.campo?.type,
                              }}
                              rules={
                                catalogo?.tipoProducto?.campo?.requerido
                                  ? {
                                      required: regex.requiredMessage,
                                      validate: {
                                        longitud: (value) => {
                                          return validarLimites(
                                            value?.length,
                                            catalogo?.tipoProducto?.campo?.max,
                                            catalogo?.tipoProducto?.campo?.min,
                                            'El dato ingresado debe ser entre ' +
                                              catalogo?.tipoProducto?.campo?.min +
                                              ' y ' +
                                              catalogo?.tipoProducto?.campo?.max +
                                              ' caracteres.'
                                          );
                                        },
                                      },
                                    }
                                  : {}
                              }
                            />
                          </SimpleContainer>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="form-group col-12 px-3 mx-3">
                    <label className="accidentes text-center py-4" style={{ fontSize: '20px' }}>
                      {catalogo?.mensajes?.coberturaBasica?.titulo}
                    </label>
                    <CheckCompuesto
                      disabled={true}
                      defaultValue={true}
                      name="coberturaBasica"
                      label={catalogo?.mensajes?.coberturaBasica?.cobertura}
                      extrasClasses="border"
                    />
                  </div>

                  <div className="form-group col-12 px-3 mx-3 mt-3">
                    <label className="accidentes text-left py-4" style={{ fontSize: '20px' }}>
                      {catalogo?.mensajes?.coberturasAdicionales?.titulo}
                      {catalogo?.mensajes?.coberturasAdicionales?.tooltip !== null && (
                        <BtnInfo
                          type="button"
                          style={{ borderRadius: '25%' }}
                          className="p-button-text p-button-plain p-0 mx-3 font-20px"
                          tooltip={catalogo?.mensajes?.coberturasAdicionales?.tooltip ?? ''}
                        >
                          <i className="pi pi-question-circle" style={{ fontSize: '1.8rem' }} />
                        </BtnInfo>
                      )}
                    </label>

                    <div className="d-flex flex-wrap border p-3">
                      <div className="row w-100 p-3">
                        <div className="col-12 m-0">
                          <div className="row w-100 mr-0">
                            {catalogo?.coberturasWOCMapped?.map((item, index) => {
                              return (
                                <div key={index + 'coberturas'} className="col-12 col-sm-12 col-md-12 cob-checkbox">
                                  {item?.map((val) => {
                                    return (
                                      <SimpleCheckBox
                                        label={val.label}
                                        name={'coberturasAdicionales.' + val.value}
                                        defaultValue={val?.value?.check || false}
                                      />
                                    );
                                  })}
                                </div>
                              );
                            })}
                          </div>
                        </div>
                        {/* <button type="button" onClick={()=>{console.log(methods.watch());}}>Test</button> */}
                        {catalogo?.coberturasWCMapped?.map((val) => {
                          return (
                            <div style={{ width: '80%' }}>
                              <div key={val.value + 'coberturas'} className="col-12 m-0 p-0">
                                <CheckCompuesto
                                  extrasClasses="p-0"
                                  habilitaCampo={val?.habilitaCampo}
                                  name={`coberturasAdicionales.${val.value}`}
                                  nodoCheck="seleccionado"
                                  nameInfo={`coberturasAdicionales.${val.value}.informacion`}
                                  label={val?.label}
                                  checkClassName={'m-0 p-0'}
                                  labelClassName={'col-12 disclaimers-auto'}
                                  labelFontSize="16px"
                                  labelFontFamily=""
                                  colLabelSize="col-5"
                                  tooltip={catalogo?.validaciones?.[val?.value]?.tooltip}
                                  estructura={{
                                    label: val?.label,
                                    value: val?.value,
                                  }}
                                  inputProps={{
                                    type: 'number',
                                    rules: {
                                      limits: (value) => {
                                        if (catalogo?.validaciones?.[val?.value]) {
                                          const msgError = catalogo?.validaciones?.[val?.value]?.habilitarMensajeTool
                                            ? catalogo?.validaciones?.[val?.value]?.msgError
                                            : catalogo?.validaciones?.[val?.value]?.msgError1;
                                          return validarLimites(
                                            value,
                                            catalogo?.validaciones?.[val?.value]?.max,
                                            catalogo?.validaciones?.[val?.value]?.min,
                                            msgError
                                          );
                                        }
                                      },
                                    },
                                    numerico: true,
                                    prefijo: '$ ',
                                  }}
                                />
                              </div>

                              {methods.watch(`coberturasAdicionales.${val.value}`)?.seleccionado &&
                                catalogo?.validaciones?.[val?.value]?.aseguradosAdicionales && (
                                  <div className="col-12 disclaimers-auto ml-5">
                                    <SimpleContainer
                                      label={catalogo?.validaciones?.[val?.value]?.aseguradosAdicionales?.label}
                                      name={`coberturasAdicionales.${val.value}.aseguradosAdicionales`}
                                      showOk={false}
                                    >
                                      <TextInputOnBlur
                                        inputProps={{
                                          name: `coberturasAdicionales.${val.value}.aseguradosAdicionales`,
                                          type: 'string',
                                        }}
                                        rules={{
                                          required: `${
                                            catalogo?.validaciones?.[val?.value]?.aseguradosAdicionales?.requiredMsg
                                          }`,
                                          validate: {
                                            longitud: (value) => {
                                              return validarLimites(
                                                value?.length,
                                                catalogo?.validaciones?.[val?.value]?.aseguradosAdicionales?.max,
                                                catalogo?.validaciones?.[val?.value]?.aseguradosAdicionales?.min,
                                                catalogo?.validaciones?.[val?.value]?.aseguradosAdicionales
                                                  ?.msgCaracteres
                                              );
                                            },
                                          },
                                        }}
                                      />
                                    </SimpleContainer>
                                  </div>
                                )}
                            </div>
                          );
                        })}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-8 col-lg-5 d-flex justify-content-center mt-5 btns-cont">
                  <Button onClick={onBack} className="w-75 btn-atras-api">
                    ATRÁS
                  </Button>
                  <Button type="submit" className="w-75">
                    CONTINUAR
                  </Button>
                </div>
                
              </div>
            </form>
          </FormProvider>
        </Page>
      </div>
    </Loading>
  );
};
